import PhoneField from '@/host/service/nestedMethod/fields/PhoneField'

export default class NestedFormManager {
  supportedFields = {
    cellPhoneNumber: PhoneField
  }

  constructor(method, $locator) {
    this.method = method
    this.$locator = $locator
    this.$store = $locator.$store

    const methodFields = this.$store.getters.getNestedMethodFields(method)
    this.fields = Object.entries(methodFields)
      .filter(([field, config]) => !!this.supportedFields[field])
      .map(([field, config]) => new this.supportedFields[field](field, config))
  }

  submit() {
    if (!this.isValid()) return false

    this.$store.dispatch('cleanError')
    this.$store.dispatch('setNestedMethodExtraFields', this.getFieldObject())

    if (this.$store.getters.isPaymentFlowMethod(this.method)) {
      this.$locator.proxy.send(
        this.$locator.storeFactory.create('createPaymentFlow')
      )
    } else {
      this.$store.dispatch('paymentStart')
      this.$store.dispatch('openRedirectionMethod', this.method)
    }

    return true
  }

  getFieldObject() {
    return this.fields.reduce((acc, field) => {
      acc[field.name] = field.value
      return acc
    }, {})
  }

  isValid() {
    const errors = this.fields
      .map(field => field.getErrors())
      .filter(error => !!error)

    if (errors.length > 0) {
      this.$store.dispatch('error', {
        errorCode: 'CLIENT_300',
        formId: null,
        children: errors
      })
      return false
    }

    return true
  }
}
